export default __webpack_public_path__ + "static/media/img4.87a9470a.png";